export class UrlHelper {
    static getBareboneUrl(url: string) {
        url = url.replace(/^https?:\/\//, '');
        

        let lastChar = url.charAt(url.length - 1);

        if (lastChar === '/') {
            url = url.slice(0, -1);
        }

        return url;
    }
}